import React from 'react'
import Link from 'gatsby-link'
import Menu from '../Menu'

const renderedItems = [];

const MobileNavigation = ( { pages, pathContext } ) => {
  return (
    <div className="navigation-menu">
      <div className="navigation-container">
        <Menu key={'mobilenav'} nodes={pages.edges} pages={pages} withChildren={true} pathContext={pathContext} mobile={true} />
      </div>
    </div>
  );
}

export default MobileNavigation



// WEBPACK FOOTER //
// ./src/components/MobileNavigation/index.js